import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";

export default function MaintenancePage() {
  const data = useStaticQuery(graphql`
    query MaintenanceLogo {
      en: sanitySitesettings(language: { eq: "en" }) {
        header {
          logo {
            alt
            asset {
              url
              gatsbyImageData(fit: FILLMAX, placeholder: BLURRED)
            }
          }
        }
      }
      es: sanitySitesettings(language: { eq: "es" }) {
        header {
          logo {
            alt
            asset {
              url
              gatsbyImageData(fit: FILLMAX, placeholder: BLURRED)
            }
          }
        }
      }
      fr: sanitySitesettings(language: { eq: "fr" }) {
        header {
          logo {
            alt
            asset {
              url
              gatsbyImageData(fit: FILLMAX, placeholder: BLURRED)
            }
          }
        }
      }
    }
  `);

  const lng = process.env.GATSBY_SANITY_LANG || "en";
  const logo = data[lng]?.header?.logo ?? data.en?.header?.logo;
  const logoImage = logo?.asset?.gatsbyImageData;

  return (
    <>
      <title>Pardon Our Dust | Inverrary</title>
      <meta
        name="description"
        content="We're currently updating our website to serve you better. Please check back soon."
      />
      <meta name="robots" content="noindex, nofollow" />
      <div className="min-h-screen flex items-center justify-center bg-lightbg px-6 py-16">
        <div className="w-full max-w-xl text-center">
          {logoImage && (
            <div className="mx-auto mb-10 w-[96px] sm:w-[120px] aspect-square">
              <GatsbyImage
                image={logoImage}
                alt={logo?.alt || "Inverrary"}
                className="w-full h-full"
                imgClassName="object-contain"
              />
            </div>
          )}
          <h1 className="font-primary text-3xl sm:text-4xl md:text-5xl font-semibold text-primary tracking-tight">
            Pardon Our Dust
          </h1>
          <p className="mt-6 text-base sm:text-lg text-secondary leading-relaxed">
            We&apos;re currently updating our website to serve you better. Thank
            you for your patience and understanding. Please check back soon.
          </p>
        </div>
      </div>
    </>
  );
}
